export default __webpack_public_path__ + "static/media/likert_disc.ceac5b34.png";